'use strict';

exports.__esModule = true;
exports.default = {
  STANDARD: 'standard',
  BUTTON_COUNT: 'button_count',
  BUTTON: 'button',
  BOX_COUNT: 'box_count'
};
//# sourceMappingURL=LikeLayout.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/LikeLayout.js
// module id = 870
// module chunks = 67997519577666